import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import Select from "react-select"
import AxiosConfig from "../../../../../../../../../utilities/AxiosConfig"
import snackBar from "../../../../../../../../../utilities/snackBar/SnackBar"
import EditIncidentTypes from "../../../../../../../Types/EditIncidentTypes"
import ReferenceTypes from "../../../../../../../Types/ReferenceTypes"
import SupervisorTypes from "../../../../../../../Types/SupervisorTypes"

interface Props {
    toggleDeleteSupervisors: Function
    appendParams: Function
    reference: ReferenceTypes
    incident: EditIncidentTypes
    userId: string | number
    removeSupervisors: Function
    readOnly: boolean
}

interface State {
    stagedSupervisors: Array<SupervisorTypes>
    saving: boolean
    isDirty: boolean
    confirmDiscard: boolean
}

class DeleteSupervisors extends Component<Props, State> {

    supervisorDex = 0
    tempSupervisorList: Array<SupervisorTypes> = []
    timeFormat = "YYYY-MM-DD"

    state = {
        stagedSupervisors: [],
        saving: false,
        isDirty: false,
        confirmDiscard: false
    }

    handleDeleteSupervisor = (supervisors: Array<any>) => {
        if (supervisors) {
            let temp = []
            for (let i = 0; i < supervisors.length; i++) {
                let supervisor = JSON.parse(supervisors[i].value)
                let newSupervisor: SupervisorTypes = {
                    IncidentSupervisorId: supervisor.IncidentSupervisorId,
                    IncidentId: supervisor.IncidentId,
                    SupervisorId: supervisor.SupervisorId,
                    SupervisorDisplayName: supervisor.SupervisorDisplayName,
                    SupervisorPhone: supervisor.SupervisorPhone,
                    SupervisorEmail: supervisor.SupervisorEmail,
                    CreatedDateUTC: moment(Date.now()).format(this.timeFormat),
                    CreatedBy: supervisor.CreatedBy,
                    DeletedDateUTC: moment(Date.now()).format(this.timeFormat),
                    DisabledDateUTC: null,
                }
                temp.push(newSupervisor)
            }
            this.setState({ stagedSupervisors: temp, isDirty: true })
        } else {
            this.setState({ stagedSupervisors: [], isDirty: false })
        }
    }

    save = () => {
        this.setState({ saving: true })
        for (let i = 0; i < this.state.stagedSupervisors.length; i++) {
            axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentSupervisorPost", this.state.stagedSupervisors[i], AxiosConfig.configValue("min"))
                .then(() => {
                    if (i === this.state.stagedSupervisors.length - 1) {
                        snackBar({ text: "Supervisor(s) removed", type: "success", timeout: 4000 })
                        this.setState({ saving: false })
                        this.props.removeSupervisors(this.state.stagedSupervisors)
                    }
                })
                .catch(err => {
                    this.supervisorDex = 0
                    this.setState({ stagedSupervisors: [], saving: false })
                    //console.log(err)
                    snackBar({ text: "Error removing supervisor(s)", type: "error", timeout: 4000 })
                    this.setState({ saving: false })
                    this.props.toggleDeleteSupervisors()
                })
        }
    }

    back = () => {
        if (!this.state.isDirty) {
            this.props.toggleDeleteSupervisors()
        } else {
            this.setState({ confirmDiscard: true })
        }
    }

    shouldDiscard = (discard: boolean) => {
        if (discard) {
            this.props.toggleDeleteSupervisors()
        } else {
            this.setState({ confirmDiscard: false })
        }
    }

    render() {

        const readOnly = this.props.readOnly

        return (
            <div className="DeleteSupervisors">
                {!this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="AddSupervisorHeader">
                            <p>Remove Supervisors</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="AddSupervisorBody">
                            {this.props.reference.supervisors && <Select
                                placeholder="Supervisors"
                                isMulti={true}
                                options={this.props.incident.Supervisors.map(s => ({ value: JSON.stringify(s), label: s.SupervisorDisplayName }))}
                                onChange={(supervisors: any) => {
                                    // this.props.appendParams([{ Supervisor: item.label }, { SupervisorId: item.value }])
                                    this.handleDeleteSupervisor(supervisors)
                                }}
                                menuPlacement="bottom"
                                maxMenuHeight={400}
                                isDisabled={readOnly}
                            />}
                            {this.state.stagedSupervisors.length > 0 && <div className="AddSupervisorSupervisorList">
                                <p id="add-supervisor-supervisor-list-header">Removing:</p>
                                {this.state.stagedSupervisors.map((supervisor: SupervisorTypes, index: number) =>
                                    <div className="AddSupervisorSupervisorListItem" key={supervisor.SupervisorId}>
                                        <p>{`${index + 1}) ${supervisor.SupervisorDisplayName}`}</p>
                                    </div>
                                )}
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="AddSupervisorFooter">
                            {!this.state.saving && <Button id="add-supervisor-back-btn" variant="secondary" onClick={() => this.back()}>Cancel</Button>}
                            {this.state.stagedSupervisors.length > 0 && !this.state.saving && <Button id="add-supervisor-save-btn" variant="danger" onClick={() => this.save()}>Remove</Button>}
                            {this.state.saving && <Spinner id="add-supervisor-saving-spinner" animation="border" />}
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.confirmDiscard && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="IncidentDiscardModalHeader">
                            <p>Are you sure you want to quit? Any unsaved changes will be lost.</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="IncidentDiscardModalFooter">
                            <Button id="add-appointment-discard-btn-dicard" variant="danger" onClick={() => this.shouldDiscard(true)}>Quit</Button>
                            <Button id="add-appointment-discard-back-btn" variant="secondary" onClick={() => this.shouldDiscard(false)} >Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default DeleteSupervisors